import "./JoinUs.css";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { useState } from "react";
import { usePartnershipWithMutation } from "../../store/query/auth";

const JoinUs = () => {
  const [partnershipWith, { isLoading, isSuccess, error }] =
    usePartnershipWithMutation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await partnershipWith(formData).unwrap();
      setFormData({ name: "", email: "", comment: "" }); // reset form
    } catch (err) {
      console.error("Partnership request error:", err);
    }
  };

  return (
    <div className="join-body" data-aos="zoom-in-up">
      <div className="join-container">
        <div className="box">
          <h2>Wish to partner with us?</h2>

          <p>
            With our team of innovative healthcare practitioners and IT
            personnels, we could offer a solution tailored to your healthcare
            facility/organization workforce needs. Kindly enter your email below
            to get started.
          </p>

          <div className="explore-employee-search-box">
            <form className="employee-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                placeholder="Message"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                required
              ></textarea>
              <div className="btn-bg">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Submit"}{" "}
                  <FaRegArrowAltCircleRight />
                </button>
              </div>
            </form>

            {/* ✅ Feedback messages */}
            {isSuccess && (
              <p className="success-text">Request sent successfully 🎉</p>
            )}
            {error && (
              <p className="error-text">Something went wrong. Try again.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
